<template>
  <div class="flex justify-center">
    <div v-if="comments && comments.length > 0">
      <button
        class="flex items-center gap-1 rounded-md bg-blue-50 px-2 py-1 text-xs text-blue-600 hover:bg-blue-100"
        @click="toggleDropdown"
      >
        <ChatBubbleLeftIcon class="size-4" />
        {{ comments?.length }}
        <ChevronDownIcon
          class="size-3 transition-transform"
          :class="{ 'rotate-180': isOpen }"
        />
      </button>
    </div>
    <div v-else>
      <span class="text-xs text-gray-400">{{ noCommentsText }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import { ChatBubbleLeftIcon, ChevronDownIcon } from '@heroicons/vue/24/outline';

interface CommentsDropdownProps {
  comments?: SubOrderComment[];
  noCommentsText?: string;
  isOpen?: boolean;
}

const props = withDefaults(defineProps<CommentsDropdownProps>(), {
  comments: () => [],
  noCommentsText: 'Sin comentarios',
  isOpen: false,
});

const emit = defineEmits<{
  toggle: [];
}>();

const isOpen = ref(props.isOpen);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
  emit('toggle');
};

watch(
  () => props.isOpen,
  (newValue) => {
    isOpen.value = newValue;
  },
);

defineExpose({
  close: () => {
    isOpen.value = false;
  },
});
</script>